/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ArtifactBatchResponse {
    getFixupPrototypeFunction() { return ArtifactBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<ArtifactBatchResponse>): ArtifactBatchResponse {
        let obj = Object.assign(new ArtifactBatchResponse(), model);
        ArtifactBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ArtifactBatchResponse>): ArtifactBatchResponse {
        if (!model) return null;
        return ArtifactBatchResponse.newInstance(<ArtifactBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ArtifactBatchResponse) {
        if (!obj) return;

        models.ArtifactBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ArtifactBatchResponse): boolean {
        Object.setPrototypeOf(obj, ArtifactBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.Artifact.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.Artifact; };

}
